import MeetingsTrainings from "../components/Meetings";
import MeetingView from "./ViewMeeting";
export default function Meetings() {
  return (
    <>
      <MeetingsTrainings />
    </>
  );
}
